export enum enumIdentifierQualifier {
  EIN = 'EI',
  SSN = '34',
  ANI = 'ANI', // CBP assigned number
}
